import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuthStore } from '../../store/authStore'
import NotificationBadge from '../NotificationBadge'
import ThemeToggle from '../ThemeToggle'


const Greetings = () => {
  const { user } = useAuthStore()



  return (
    <div className="relative flex justify-between items-center">
      <div>
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">Hi, {user?.firstName || 'User'}</h1>
        <p className="text-gray-600 dark:text-gray-400 text-sm">Keep track of all your activities here</p>
      </div>
      
      <div className="flex items-center space-x-4">
        {/* Notification Icon with Badge */}
        <NotificationBadge className="hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full !text-inherit" />
    
        {/* Dark Mode Toggle */}
        <ThemeToggle />
        {/* User Avatar */}
        <div className="hidden md:flex w-10 h-10 rounded-full border-[1px] border-white dark:border-[#32353c] bg-gray-200 dark:bg-[#32353c] overflow-hidden">
          <img 
            src={user?.profilePicture || "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=40&h=40&fit=crop&crop=face"} 
            alt="User" 
            className="w-full h-full object-cover" 
          />
        </div>
      </div>


    </div>
  )
}

export default Greetings